import axios, { AxiosStatic } from 'axios'

// create a new axios instance
const api = axios.create({
  headers: {
    'Content-Type': 'application/json',
  }
})

// avoid type errors on this.$api
declare module 'vue/types/vue' {
  interface Vue {
    $api: AxiosStatic;
  }
}

export default api

